import React, { useState, useEffect } from 'react';
import './EditorStyles.css';

const ServiceModal = ({ service, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    title_ar: '',
    title_en: '',
    description_ar: '',
    description_en: '',
    image_url: '',
    display_order: 0,
    is_active: true
  });
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    if (service) {
      setFormData({
        title_ar: service.title_ar || '',
        title_en: service.title_en || '',
        description_ar: service.description_ar || '',
        description_en: service.description_en || '',
        image_url: service.image_url || '',
        display_order: service.display_order || 0,
        is_active: service.is_active !== undefined ? service.is_active : true
      });
    }
  }, [service]);

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploading(true);
    const formData = new FormData();
    formData.append('image', file);

    try {
      const token = localStorage.getItem('dashboard_token');
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'https://server.acpca.net/api'}/upload/image`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
        },
        body: formData
      });

      const data = await response.json();
      if (data.success) {
        const baseUrl = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL.replace('/api', '') : 'https://server.acpca.net';
        const imageUrl = `${baseUrl}${data.url.startsWith('/') ? data.url : `/${data.url}`}`;
        handleChange('image_url', imageUrl);
      }
    } catch (error) {
      console.error('Upload error:', error);
    } finally {
      setUploading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <div className="editor-modal-overlay" onClick={onClose}>
      <div className="editor-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="editor-modal-header">
          <h2>{service ? 'تعديل الخدمة' : 'إضافة خدمة جديدة'}</h2>
          <button className="editor-modal-close" onClick={onClose}>×</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="editor-grid">
            <div className="editor-column">
              <h3>المحتوى العربي</h3>
              <div className="editor-form-group">
                <label>العنوان *</label>
                <input
                  type="text"
                  value={formData.title_ar}
                  onChange={(e) => handleChange('title_ar', e.target.value)}
                  required
                />
              </div>
              <div className="editor-form-group">
                <label>الوصف</label>
                <textarea
                  rows="4"
                  value={formData.description_ar}
                  onChange={(e) => handleChange('description_ar', e.target.value)}
                />
              </div>
            </div>

            <div className="editor-column">
              <h3>المحتوى الإنجليزي</h3>
              <div className="editor-form-group">
                <label>Title (English) *</label>
                <input
                  type="text"
                  value={formData.title_en}
                  onChange={(e) => handleChange('title_en', e.target.value)}
                  required
                />
              </div>
              <div className="editor-form-group">
                <label>Description (English)</label>
                <textarea
                  rows="4"
                  value={formData.description_en}
                  onChange={(e) => handleChange('description_en', e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className="editor-form-group">
            <label>رابط الصورة</label>
            <div className="editor-image-input">
              <input
                type="text"
                value={formData.image_url}
                onChange={(e) => handleChange('image_url', e.target.value)}
                placeholder="رابط الصورة أو رفع ملف"
              />
              <label className="editor-upload-btn">
                {uploading ? 'جاري الرفع...' : 'رفع صورة'}
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleImageUpload}
                  style={{ display: 'none' }}
                  disabled={uploading}
                />
              </label>
            </div>
            {formData.image_url && (
              <img src={formData.image_url} alt="Preview" className="editor-image-preview" />
            )}
          </div>

          <div className="editor-form-group">
            <label>ترتيب العرض</label>
            <input
              type="number"
              value={formData.display_order}
              onChange={(e) => handleChange('display_order', parseInt(e.target.value) || 0)}
            />
          </div>

          <div className="editor-form-group">
            <label>
              <input
                type="checkbox"
                checked={formData.is_active}
                onChange={(e) => handleChange('is_active', e.target.checked)}
              />
              {' '}نشط
            </label>
          </div>

          <div className="editor-actions">
            <button type="submit" className="editor-btn-save" disabled={uploading}>
              {service ? 'حفظ التغييرات' : 'إضافة الخدمة'}
            </button>
            <button type="button" className="editor-btn-secondary" onClick={onClose}>
              إلغاء
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ServiceModal;

